var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement, property } from 'lit/decorators.js';
let TextInputComponent = class TextInputComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this._searchDebounce = 0;
    }
    static get styles() {
        return [
            ...super.styles,
            css `
        .slds-input::placeholder {
          color: #747474;
          font-size: .875rem;
        }
        .slds-input:focus {
          border-color: #1b96ff;
        }
        .slds-input:hover {
          border-color: #1b96ff;
        }
      `,
        ];
    }
    render() {
        return html `
      <input
        style="width: 100%;"
        type="text"
        class="slds-input"
        placeholder="${this.placeholder}"
        @input="${(e) => {
            clearTimeout(this._searchDebounce);
            const searchValue = e.target.value;
            this._searchDebounce = window.setTimeout(() => {
                this.dispatchEvent(new CustomEvent('text-input', { detail: searchValue }));
            }, 200);
        }}"
      />
    `;
    }
};
__decorate([
    property({ type: String })
], TextInputComponent.prototype, "placeholder", void 0);
TextInputComponent = __decorate([
    customElement('ggo-text-input')
], TextInputComponent);
export { TextInputComponent };
